export interface UiMessage {
    message: string
    type: UiMessageType
}

export enum UiMessageType {
    ERROR,
    INFO
}
